import { render } from "./course_list_private.vue?vue&type=template&id=72777910"
import script from "./course_list_private.vue?vue&type=script&lang=js"
export * from "./course_list_private.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__